module.exports = __webpack_public_path__ + "9912a61ca342111bee981004f6b1c579.svg";